export const deClientPortalAssetDeviationAnalysis = {
    emptyStateTitle: 'Für diese Immobilie liegen noch nicht genügend Bewertungen vor.',
    energyInfoBox: {
        condensedTitle: 'Energiekennzahlen',
        spaciousSectionLabel: 'ESG',
        spaciousTitle: 'Energiewerte',
        labels: {
            primaryPowerConsumption: 'Primärenergiebedarf',
        },
        units: {
            primaryPowerConsumption: 'kWh/m²a',
            carbonDioxideEquivalent: 'kg',
        },
        fuelTypeLabels: {
            wood: 'Holz',
            gas: 'Gas',
            oil: 'Öl',
            environmentalSoil: 'Umweltw. (Boden)',
            environmentalAir: 'Umweltw. (Außenluft)',
            environmentalSolar: 'Umweltw. (Solarthermie)',
            electricPower: 'Strom',
            erdgas: 'Erdgas',
            fluessiggas: 'Flüssiggas',
            heizoelEl: 'Heizöl',
            strom: 'Strom',
            nahFernwaerme: 'Nah',
            holzpellets: 'Holzpellets',
            holzhackschnitzel: 'Holzhackschnitzel',
            stueckholz: 'Stückholz',
            waermepumpe: 'Wärmepumpe',
            solarthermie: 'Solarthermie',
            geothermie: 'Geothermie',
            umweltwaerme: 'Umweltwärme',
            hybridSystem: 'Hybrid',
            biogasBiomethan: 'Biogas',
            steinkohle: 'Steinkohle',
            braunkohle: 'Braunkohle',
        },
    },
}
